var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import { Pane, Button, Row, Col, AccordionSet, Accordion, PaneFooter, ErrorModal, } from "@folio/stripes/components";
import { useForm, FormProvider } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormattedMessage, useIntl } from "react-intl";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { CollectionGeneralFields } from "../../components/CollectionGeneralFields";
import { CollectionOtherLanguageNamesFields } from "../../components/CollectionOtherLanguageNamesFields";
import { createCollectionSchema } from "../../utils/validationUtils";
import { collectionInitialValues } from "../../utils/collectionInitialValues";
import { useScrollToError } from "../../hooks/useScrollToError";
var CollectionForm = function (_a) {
    var initialValues = _a.initialValues, onSubmit = _a.onSubmit, title = _a.title, onCancel = _a.onCancel;
    var formatMessage = useIntl().formatMessage;
    var methods = useForm({
        resolver: zodResolver(createCollectionSchema(formatMessage)),
        shouldFocusError: false,
        defaultValues: __assign(__assign({}, collectionInitialValues), initialValues),
        mode: "onBlur",
    });
    var handleSubmit = methods.handleSubmit, _b = methods.formState, errors = _b.errors, isSubmitting = _b.isSubmitting, reset = methods.reset;
    var _c = useState({
        general: true,
        otherLanguageNames: true,
    }), accordionStatus = _c[0], setAccordionStatus = _c[1];
    var _d = useState(false), errorModalOpen = _d[0], setErrorModalOpen = _d[1];
    var _e = useState(""), errorMessage = _e[0], setErrorMessage = _e[1];
    var _f = useState(true), expandAll = _f[0], setExpandAll = _f[1];
    useEffect(function () {
        reset(function (prev) { return (__assign(__assign({}, prev), initialValues)); });
    }, [initialValues, reset]);
    useScrollToError(errors);
    var submit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, onSubmit(data)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error("Collections submit failed:", error_1);
                    setErrorMessage(formatMessage({ id: "ui-br-agency.collections.error.submit" }));
                    setErrorModalOpen(true);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var toggleExpandCollapseAll = function () {
        setAccordionStatus({
            general: !expandAll,
            otherLanguageNames: !expandAll,
        });
        setExpandAll(!expandAll);
    };
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: title, footer: React.createElement(PaneFooter, { renderStart: React.createElement(Button, { buttonStyle: "primary", type: "submit", disabled: isSubmitting, onClick: handleSubmit(submit) },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.save" })), renderEnd: React.createElement(Button, { buttonStyle: "default", onClick: onCancel },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.cancel" })) }) },
            React.createElement(ErrorModal, { open: errorModalOpen, label: formatMessage({
                    id: "ui-br-agency.modal.label.error",
                }), content: errorMessage, onClose: function () { return setErrorModalOpen(false); } },
                React.createElement("div", null, errorMessage),
                React.createElement(Button, { onClick: function () { return setErrorModalOpen(false); } },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.close" }))),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12, style: { display: "flex", justifyContent: "flex-end" } },
                    React.createElement(Button, { onClick: toggleExpandCollapseAll, buttonStyle: "default" }, expandAll
                        ? formatMessage({ id: "ui-br-agency.button.collapse" })
                        : formatMessage({ id: "ui-br-agency.button.expand" })))),
            React.createElement(FormProvider, __assign({}, methods),
                React.createElement("form", { noValidate: true, onSubmit: handleSubmit(onSubmit) },
                    React.createElement(AccordionSet, null,
                        React.createElement(Accordion, { label: formatMessage({
                                id: "ui-br-agency.collections.accordions.label.general",
                            }), open: accordionStatus.general, onToggle: function () {
                                return setAccordionStatus(__assign(__assign({}, accordionStatus), { general: !accordionStatus.general }));
                            } },
                            React.createElement(CollectionGeneralFields, { initialValues: initialValues })),
                        React.createElement(Accordion, { label: formatMessage({
                                id: "ui-br-agency.collections.accordions.label.otherLanguageNames",
                            }), open: accordionStatus.otherLanguageNames, onToggle: function () {
                                return setAccordionStatus(__assign(__assign({}, accordionStatus), { otherLanguageNames: !accordionStatus.otherLanguageNames }));
                            } },
                            React.createElement(CollectionOtherLanguageNamesFields, null))))))));
};
export default CollectionForm;
